"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const EditControl_module_css_1 = __importDefault(require("./styles/EditControl.module.css"));
const VerticalDots_1 = __importDefault(require("../svg/VerticalDots"));
const ClickablePopover_1 = __importDefault(require("../organisms/ClickablePopover"));
const EditControl = ({ controls }) => {
    const renderButton = (0, react_1.useCallback)((useShow, ref) => {
        return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, Object.assign({ ref: ref, variant: "secondary", className: `${EditControl_module_css_1.default.btn || ""} btn_onlyicon btn-ghost`, onClick: useShow }, { children: (0, jsx_runtime_1.jsx)(VerticalDots_1.default, {}) })));
    }, []);
    const renderBody = (0, react_1.useCallback)((useShow) => {
        return controls.map((control) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: EditControl_module_css_1.default.controlBtn, onClick: () => {
                useShow();
                control.onClick();
            } }, { children: control.title }), control.title)));
    }, [controls]);
    return (0, jsx_runtime_1.jsx)(ClickablePopover_1.default, { popoverClassName: EditControl_module_css_1.default.overlay, renderControl: renderButton, renderBody: renderBody });
};
exports.default = EditControl;
